import React, { useRef, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import img from "../assets/images/text-slider-vec.svg";
import { useGeneralInfo } from "../context/generalContext";

const moveTicker = (distance) => keyframes`
  0% {
    transform: translateX(70%);
  }
  100% {
    transform: translateX(-${distance}px);
  }
`;

const Wrapper = styled.div`
  overflow: hidden;
  white-space: nowrap;
  //   width: 98.5vw; /* Ensures it takes the full viewport width */
  // background-color: rgba(0, 0, 0, 0.8);
  background-color: rgba(0, 0, 0, 0.9); /* Adjust transparency */
  // backdrop-filter: blur(10px);
  // -webkit-backdrop-filter: blur(16px);
  padding: 25px 0px;
  box-sizing: border-box;
  color: white;
  margin-bottom: 90px;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  animation: ${(props) => moveTicker(props?.distance)} 50s linear infinite;
  width: 20vw;
`;

const Element = styled.div`
  display: inline-block;
  font-family: "Quicksand";
  margin: 0 30px;
`;
const ElementWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 400px;
  padding: 0px 20px;
`;
const NewsTicker = ({ handleLoop }) => {
  // console.log("items", items);
  const innerRef = useRef(null);
  const [distance, setDistance] = useState(0);
  const [generalInfo, setGeneralInfo] = useGeneralInfo();


  const usedCars = generalInfo?.cars
    ?.filter((data) => data?.category?.category_type === "Used Cars")
    ?.map((data) => data);


  const items = [
    { key: "TO GET YOUR DREAM CAR", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    {
      key: `${usedCars?.length} USED CARS AVAILABLE`,
      img: <img src={img} alt="" />,
    },
    { key: "TO GET YOUR DREAM CARS", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    {
      key: `${usedCars?.length} USED CARS AVAILABLE`,
      img: <img src={img} alt="" />,
    },
    { key: "TO GET YOUR DREAM CARS", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    {
      key: `${usedCars?.length} USED CARS AVAILABLE`,
      img: <img src={img} alt="" />,
    },
    { key: "TO GET YOUR DREAM CARS", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    {
      key: `${usedCars?.length} USED CARS AVAILABLE`,
      img: <img src={img} alt="" />,
    },
    // add more items as needed
  ];

  useEffect(() => {
    const element = innerRef.current;
    if (element) {
      const totalWidth = element.scrollWidth;
      setDistance(totalWidth);
    }
  }, [items]);
  return (
    <Wrapper>
      <Inner ref={innerRef} distance={distance} onAnimationEnd={handleLoop}>
        {items?.map((obj, index) => (
          <ElementWrapper>
            <Element key={obj.key + index}>{obj.key}</Element>
            {obj.img}
          </ElementWrapper>
        ))}
      </Inner>
    </Wrapper>
  );
};

export default NewsTicker;
